export function EditorToolbarSeparator() {
  return (
    <span
      data-react-fancy-editor-toolbar-separator=""
      className="mx-1 h-5 w-px bg-zinc-200 dark:bg-zinc-700"
    />
  );
}

EditorToolbarSeparator.displayName = "EditorToolbarSeparator";
